module.exports = __webpack_public_path__ + "static/media/28.347f88f5.JPG";